import styled from 'styled-components';

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  max-width: 640px;
  margin: 0 auto;
  padding: 0 0.25rem;
`;

export const StepIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
`;

export const StepLabel = styled.span`
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const StepTitle = styled.span`
  font-size: 0.82rem;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const StepContent = styled.div`
  font-size: 0.9rem;

  h2 {
    font-size: 1.05rem !important;
    font-weight: 600;
    margin-bottom: 0.35rem;
  }

  p {
    font-size: 0.85rem;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;

export const PreviewPanel = styled.details`
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  padding: 0.5rem 0.75rem;
  background: ${({ theme }) => theme.colors.background};

  summary {
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.text.secondary};
    list-style: none;

    &::-webkit-details-marker {
      display: none;
    }
  }
`;

export const PreviewText = styled.pre`
  margin: 0.5rem 0 0;
  font-size: 0.75rem;
  line-height: 1.45;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.colors.text.secondary};
  max-height: 140px;
  overflow: auto;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
  gap: 0.5rem;
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 0.5rem;
`;
